export const Header = () => (
    <div className="jumbotron">
      <h1 className="display-4">Impôt, deux pots</h1>
      <h2 className="display-6">
          Un outil simple pour individualiser l'impôt au sein du couple.
      </h2>
      <div className="container py-4 px-0">
        <div className="row col-12 col-xl-11">
          <p className="my-1">
            En France, les couples mariés ou pacés sont obligés de faire une déclaration de revenus commune.
            L'administration fiscale réclame ou reverse ensuite une somme globale au couple, sans distinguer
            la part de chacun·e.
            Le prélèvement à la source individualisé est un début de réponse, mais qui ne s'applique pas à toutes
            les situations (travailleur·euse·s indépendant·e·s, forte variation de revenus d'une année sur l'autre, etc.).
          </p>
          <p className="my-1">
            Ce fonctionnement peut léser les personnes qui ont choisi de conserver une indépendance
            financière au sein du couple, en particulier si les différences de revenus sont importantes.
          </p>
          <p className="my-1">
            À partir de votre dernière déclaration commune, <i>Deux pots</i> calcule le montant que 
            chacun·e doit payer ou récupérer.
          </p>
        </div>
      </div>
    </div>
)